/**
 * Provides JS functionality for tracking alert display.
 */
export class Slider extends DrupalBehavior {
  onContent(context) {
    $('.slider__items', context).each(function (index) {
      let prevArrow = $(this).find('.slide__arrow--prev', context);
      let nextArrow = $(this).find('.slide__arrow--next', context);

      $(this).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow,
        nextArrow,
        dots: false,
      });
    });
  }
}

DrupalBehavior.register('rush_theme.components', 'slider', Slider);
